import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.viewer');
import { OnInit } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-layout-viewer',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.viewer/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class LayoutViewerComponent implements OnInit {
    public activeMenu: string = '';
    public ready: boolean = false;
    public password: string = '';
    public error: string = '';
    public loading: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router,@Inject( ChangeDetectorRef)  public ref: ChangeDetectorRef) { }

    public menus = [
        { label: '허브', path: '/hub', icon: 'home' },
        { label: '프레젠테이션', path: '/presentation', icon: 'presentation' },
        { label: '대본', path: '/script', icon: 'script' }
    ];

    public async ngOnInit() {
        await this.service.init(this);

        let { code } = await wiz.app("layout.viewer").call("check");
        if (code === 200) this.ready = true;

        this.updateActiveMenu();
        this.router.events.subscribe(() => {
            this.updateActiveMenu();
            this.service.render();
        });
        await this.service.render();
    }

    private updateActiveMenu() {
        this.activeMenu = location.pathname;
    }

    public isActive(path: string): boolean {
        return this.activeMenu === path;
    }

    public navigate(path: string) {
        this.service.href(path);
    }

    public async verify() {
        if (!this.password) {
            this.error = '비밀번호를 입력해주세요.';
            await this.service.render();
            return;
        }
        this.loading = true;
        this.error = '';
        await this.service.render();

        let { code, data } = await wiz.app("layout.viewer").call("verify", { password: this.password });
        this.loading = false;
        if (code === 200) {
            this.ready = true;
            this.navigate('/hub');
        } else {
            this.error = data.message || '비밀번호가 올바르지 않습니다.';
        }
        await this.service.render();
    }

    public async logout() {
        await wiz.app("layout.viewer").call("logout");
        this.ready = false;
        this.password = '';
        this.error = '';
        await this.service.render();
    }
}

export default LayoutViewerComponent;